export const WALLET_URL_DEV_BASE = "https://dev.wallet.meteorwallet.app";
export const WALLET_URL_PRODUCTION_BASE = "https://wallet.meteorwallet.app";
export const WALLET_URL_LOCALHOST_BASE = "https://localhost:3000";
